import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";

export const DropPlayerDialog = ({open, handleClose, dropRow, handleDropPlayer}) => {
    return (
        <Dialog open={open} onClose={handleClose} closeAfterTransition={false}>
            <DialogTitle id="drop-player-dialog">
                Drop player?
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {`${dropRow.first_name} ${dropRow.last_name} - ${dropRow.pos} - ${dropRow.team}`}
                </DialogContentText>
                <DialogContentText>
                    Penalty will be {`${dropRow.penalty ? dropRow.penalty : 0}`}
                </DialogContentText>
                <Button variant="outlined" type="submit" color="primary" style={{margin: 20}}
                        onClick={handleClose}>Cancel</Button>
                <Button variant="contained" type="submit" color="primary" style={{margin: 20}}
                        onClick={handleDropPlayer}>Drop</Button>
            </DialogContent>
        </Dialog>
    );
}